import React from 'react';
import { Truck, Wrench, Phone } from 'lucide-react';
export function TopBar() {
  return <div className="bg-brand-green text-white py-2 px-4 text-sm font-medium" data-id="element-643">
      <div className="max-w-7xl mx-auto flex justify-center items-center text-center" data-id="element-644">
        {/* Mobile View */}
        <div className="md:hidden flex items-center justify-center gap-3 space-x-2" data-id="element-645">
          <span className="flex items-center gap-1.5" data-id="element-646">
            <Truck size={14} data-id="element-647" /> Nationwide shipping
          </span>
          <span className="opacity-50" data-id="element-648">•</span>
          <a href="tel:301-620-7585" className="flex items-center gap-1.5 hover:text-brand-gold transition-colors" data-id="element-649">
            <Phone size={14} data-id="element-650" /> Call 301-620-7585
          </a>
        </div>

        {/* Desktop View */}
        <div className="hidden md:flex items-center justify-center gap-4" data-id="element-651">
          <span className="flex items-center gap-1.5" data-id="element-652">
            <Truck size={16} data-id="element-653" /> Nationwide shipping
          </span>
          <span className="opacity-50" data-id="element-654">•</span>
          <span className="flex items-center gap-1.5" data-id="element-655">
            <Wrench size={16} data-id="element-656" /> Installation available in select Mid-Atlantic
            areas
          </span>
          <span className="opacity-50" data-id="element-657">•</span>
          <a href="tel:301-620-7585" className="flex items-center gap-1.5 hover:text-brand-gold transition-colors" data-id="element-658">
            <Phone size={16} data-id="element-659" /> Call 301-620-7585
          </a>
        </div>
      </div>
    </div>;
}